import { easing as easingProgress, clampScope, } from '@anton.bobrov/vevet-init';
var GLOBAL_SCOPE = [0, 1];
var EXPAND_SCOPE = [0, 0.75];
var ALPHA_SCOPE = [0.5, 1];
export function render(_a) {
    var parentRef = _a.parentRef, contentRef = _a.contentRef, timeline = _a.timeline, p = _a.p, hasAlpha = _a.hasAlpha, onRender = _a.onRender, onEnd = _a.onEnd;
    var parent = parentRef.current;
    var content = contentRef.current;
    if (!parent || !content || !timeline) {
        return;
    }
    // calculate progress
    var heightProgress = easingProgress(clampScope(p, hasAlpha ? EXPAND_SCOPE : GLOBAL_SCOPE));
    var contentProgress = easingProgress(clampScope(p, hasAlpha ? ALPHA_SCOPE : GLOBAL_SCOPE));
    // animate height
    parent.style.height =
        p === 1 ? 'auto' : "".concat(content.offsetHeight * heightProgress, "px");
    // animate visibility
    content.style.visibility = p === 0 ? 'hidden' : 'visible';
    // animate alpha
    if (hasAlpha) {
        content.style.opacity = "".concat(contentProgress);
    }
    // render callbacks
    onRender === null || onRender === void 0 ? void 0 : onRender({ content: content, progress: contentProgress });
    // end callbacks
    if (timeline.isReversed && p === 0) {
        onEnd === null || onEnd === void 0 ? void 0 : onEnd(false);
    }
    else if (!timeline.isReversed && p === 1) {
        onEnd === null || onEnd === void 0 ? void 0 : onEnd(true);
    }
}
//# sourceMappingURL=render.js.map